import { Box } from '@cad-arc';
import { EventPanelTab, tabComponents } from './event-panel-tabs-config';

export function FullModeActiveTab({ activeTab }: { activeTab: EventPanelTab }) {
    const TabComponent = tabComponents[activeTab];
    return (
        <Box flexGrow={1000000} w="100%" minHeight={0}>
            {!TabComponent ? undefined : <TabComponent />}
        </Box>
    );
}
